import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const TitleText = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
  padding-bottom: 20px;
`;

export const OtherLabel = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
